<div class="container">
    <div class="container-row">
        <div class="back-button-container">
            <button routerLink="/" routerLinkActive="active" (click)="goBack()">back</button>
        </div>
        <div class="container">
            <h1>Employee Details</h1>
        </div>
    </div>
    
    <!-- Develop this div appropriately -->
    <div class="card-container">
        <a class="card" routerLink="/facilities/employeeDetails/searchEmployee" routerLinkActive="active" (click)="goToPage('searchEmployee')">
          <img src="assets/images/employee.png" alt="Search Employee">
      
          <span>Search Employee</span>
        </a>
      
        <a class="card" routerLink="/facilities/employeeDetails/registerEmployee" routerLinkActive="active" (click)="goToPage('registerEmployee')">
            <img src="assets/images/profile.png" alt="Employee details">
      
          <span>Register New Employee </span>
        </a>
    </div>
</div>